var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOfferSnooker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,13h26a3,3 0,0 1,3 3v16a3,3 0,0 1,-3 3H11a3,3 0,0 1,-3 -3V16a3,3 0,0 1,3 -3z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16h24v16H12z",
    fill: "#16A34A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18,21m-2.2,0a2.2,2.2 0,1 0,4.4 0a2.2,2.2 0,1 0,-4.4 0",
    fill: "#7C1CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24m-2.2,0a2.2,2.2 0,1 0,4.4 0a2.2,2.2 0,1 0,-4.4 0",
    fill: "#E53935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,21m-2.2,0a2.2,2.2 0,1 0,4.4 0a2.2,2.2 0,1 0,-4.4 0",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOfferSnooker);
export default __webpack_public_path__ + "static/media/p4r_business_offer_snooker.30373ad94e61ad78bc993ca0db20e59c.svg";
export { ForwardRef as ReactComponent };